import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import { ff } from '@atlassian/jira-feature-flagging';
import { fg } from '@atlassian/jira-feature-gating';

export const CONTEXTUAL_BULK_OPS_ANALYTICS_CHANGES = 'contextual-bulkops-analytics-changes_bisrw';

export const isContextualBulkOpsAnalyticsChangesEnabled = () =>
	ff('contextual-bulkops-analytics-changes_bisrw');

export const isLinkIssueFromBoardCardEnabled = (
	{ fireExperimentExposure } = { fireExperimentExposure: false },
): boolean => {
	const [expConfig, fireExposure] = UNSAFE_noExposureExp('jsw_link_issues_from_board_cards');

	if (fireExperimentExposure) {
		fireExposure();
	}

	return (
		// LD feature flag wrapper required to release to Release Track enrolled customers
		// https://app.launchdarkly.com/jira/staging/features/jsw.perf.issue-links-on-board-cards
		ff('jsw.perf.issue-links-on-board-cards') &&
		// Check if Milestone 1 for issue links is enabled
		// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/gates/jsw_enable_issue_linking_from_jsw_board_cards_m1
		fg('jsw_enable_issue_linking_from_jsw_board_cards_m1') &&
		// check if the experiment is enabled
		// https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/experiments/jsw_link_issues_from_board_cards
		expConfig.get('enableIssueLinkExperiment', false)
	);
};
